module.exports = __webpack_public_path__ + "static/media/icon-payment-success.9ccabcfc.svg";